<template>
    <div class="content page-1">
        <section class="section-order section-white">
            <h2 class="text-green">Bestill reise:</h2>
            <h3>Du er i gang med å bestille din reise.<br/>Velg først antall reisende og deretter romtype.</h3>
            <p>Enerom er alltid beregnet til én person, og dobbeltrom er i utgangspunktet beregnet til 2
                personer.</p>

            <div class="split pb-1" v-if="selectedStartDate.airport">
                <h4 class="col1">Avreise:</h4>
                <div class="col2">
                    <dropdown
                            className="mw-246"
                            v-if="startDates.length > 0"
                            :options="startDates"
                            :selected="selectedStartDate"
                            :placeholder="'Select an Item'"
                            @updateOption="changeStartDate"
                            :closeOnOutsideClick="true">
                    </dropdown>
                    <strong class="input-error input-error-left" v-if="selectedStartDate.capacity === 0">Den valgte datoen er dessverre utsolgt, vennligst velg en annen
                        dato</strong>
                </div>
            </div>

            <div class="split">
                <h4 class="col1">Hjemkomst:</h4>
                <p class="col2">{{ returnDate }}</p>
            </div>

            <div class="split">
                <h4 class="col1">Pris fra:</h4>
                <p class="col2">Kr. {{ bookingData.priceFrom | nok }}</p>
            </div>

            <div class="split">
                <h4 class="col1">Antall dager:</h4>
                <p class="col2">{{ selectedStartDate.days }}</p>
            </div>
        </section>

        <section class="section-order section-white">
            <h2>Antall personer</h2>
            <PlusMinusInput
                    :value="$store.getters.numberOfTravellers"
                    @increased="$store.commit('addTraveller')"
                    @decreased="$store.commit('removeTraveller')"
                    :min="1"
            />
        </section>

        <section class="section-order section-white mb-6">
            <h2>Antall rom</h2>
            <div class="split split-three" v-for="room in availableRooms" :key="room.productUnitId">
                <div class="col1">
                    <PlusMinusInput
                            :max="room.maxCapacity"
                            @input="updatedRoomBooking(room, $event)"
                            :value="$store.state.rooms[room.productUnitId] ? $store.state.rooms[room.productUnitId].length : 0"
                            v-if="room.maxCapacity > 0"/>
                </div>
                <div class="col2">{{room.name}}</div>
                <div class="col3" v-if="room.maxCapacity > 0">kr {{room.price|nok}} pr. person</div>
                <div class="col3" v-else>Utsolgt</div>
            </div>

            <div v-if="!$store.getters.canFitAllTravelers && $store.state.isRoomSelectionDirty">
                <div class="input-error">
                    Du har valgt en romkombinasjon som ikke samsvarer med antall gjester,
                    f.eks dobbeltrom for enkelt-gjest, eller enkeltrom for 2 gjester, sørg for at du har en kombinasjon som fungerer før du går videre.
                </div>
            </div>
        </section>


        <portal to="navButtons">
            <button
                    class="checkout-button button button-fat float-right" @click="goToNextStep" :class="{disabled: !canGoToNextStep}">
                Fortsett
            </button>
        </portal>


        <portal to="overviewButtons">
            <button class="overview-button button button-fat w-100" @click="goToNextStep" :class="{disabled: !canGoToNextStep}">
                Fortsett til neste trinn
            </button>
        </portal>


    </div>
</template>
<script>
    import Dropdown from "../Dropdown";
    import PlusMinusInput from "../PlusMinusInput";
    import {mapGetters, mapState} from 'vuex'


    export default {
        name: "Page1",
        components: {
            PlusMinusInput,
            Dropdown
        },

        computed: {
            ...mapState([
                'bookingData',
            ]),
            ...mapGetters([
                'availableRooms',
                'startDates',
                'selectedStartDate'
            ]),
            returnDate() {
                return this.$store.getters.returnDate.toLocaleDateString("no-NB", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                })
            },
            canGoToNextStep: {
                cache: false,
                get() {
                    return this.$store.getters.canFitAllTravelers && this.$store.getters.selectedStartDate.capacity > 0
                },
            },
        },
        methods: {
            goToNextStep() {
                if (!this.canGoToNextStep) {
                    this.$store.state.isRoomSelectionDirty = true;
                    return false;
                }
                this.$router.push({name: 'page2'});
            },

            updatedRoomBooking(room, value) {
                this.$store.commit('updateRoomSelection', {
                    productUnitId: room.productUnitId,
                    amount: value
                })
            },
            changeStartDate(option) {
                this.$store.commit('setTourStartDateId', parseInt(option.tourStartDateId));
                this.$store.dispatch("refreshData");
            }
        }
    };
</script>
